import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Winona",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/states/minnesota",
  heroImageQuery:
    "Aerial view of Winona Minnesota scenic river bluff city, historic downtown along the Mississippi River with majestic limestone bluffs rising behind the city, Winona State University campus visible on the bluff, Sugar Loaf peak and Lake Winona in the foreground, Granddad Bluff overlook, classic Victorian architecture along Main Street, lush green summer landscape with the river reflecting golden hour sunlight, professional aerial photography, no readable signs or text",
  heroImageSeq: "winona-mn-hero-2026",
  heroDescription:
    "Study abroad departure in three weeks and your passport expired? Wisconsin road trip to pick up a festival ticket with no valid passport? European heritage trip with a month to spare? We help Winona residents — from Winona State University students and faculty to Mississippi River bluff families and island city artisans — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other resellers. As fast as 24 hours. A+ BBB rated.",
  geoPosition: "44.0554; -91.6664",
  geoPlacename: "Winona, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/winona/",
  localAreaTitle: "Serving Winona & the Mississippi River Bluff Country",
  localAreaText: [
    "Winona, Minnesota is a scenic river bluff city nestled along the Mississippi River in southeast Minnesota. Known as the 'Island City' because it's surrounded by the river and Lake Winona, Winona is celebrated for its dramatic limestone bluffs, historic architecture, and vibrant arts community. The city serves as the county seat of Winona County and is a regional center for education, healthcare, and manufacturing.",
    "Winona State University, founded in 1858, is the oldest normal school west of the Mississippi and anchors the city's educational identity. The university attracts students from across the Midwest and maintains active study abroad programs in Europe, Asia, and Latin America. Saint Mary's University of Minnesota, a private Lasallian Catholic university, adds to the city's academic community with its own international programs.",
    "The city's historic downtown along Main Street features well-preserved Victorian architecture, the iconic Sugar Loaf peak, and the Minnesota Marine Art Museum. The Levee Park and the Mississippi River provide a stunning backdrop for outdoor activities. The bluff-top Garvin Heights overlook offers panoramic views of the river valley.",
    "Winona's proximity to Wisconsin (just across the river) and its position along the Great River Road create unique travel patterns. Residents frequently cross into Wisconsin and Iowa for work, recreation, and shopping. The city's location along I-90 and U.S. Highway 61 makes it accessible to La Crosse, Rochester, and the Twin Cities. The presence of two universities means a steady stream of student study abroad, faculty research travel, and international academic partnerships.",
  ],
  nearbyCities: [
    { name: "Winona", zips: "55987" },
    { name: "Goodview", zips: "55987" },
    { name: "Rollingstone", zips: "55969" },
    { name: "Lewiston", zips: "55952" },
    { name: "St. Charles", zips: "55972" },
    { name: "Altura", zips: "55910" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required. Complete your order from your Winona home or campus dorm in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Overnight shipping from any UPS or FedEx location in the Winona area.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application reviewed before submission to catch errors that cause delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "Reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Winona & Southeast Minnesota River Country",
  serviceAreaDescription: "Serving Winona County and southeast Minnesota communities with overnight courier",
  faqs: [
    {
      q: "How fast can I get a passport in Winona, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a Winona area post office can take 2–6 months — not suitable for upcoming trips.",
    },
    {
      q: "Can Winona State University students get passports before study abroad?",
      a: "Absolutely. Study abroad students are one of our most common Winona clients. We regularly process expedited renewals and new applications for Winona State and Saint Mary's students preparing for semester programs in Europe, Asia, and Latin America — as fast as 2–9 business days.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center from Winona?",
      a: "No — most Winona travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Winona. You can ship from FedEx or UPS locations nearby.",
    },
    {
      q: "My family is planning a European heritage trip. How early should we start passport renewals?",
      a: "We recommend starting at least 8 weeks before departure for standard expedited processing. If you are within 3 weeks of departure, you likely need our faster 2–9 business day option. Many Winona families with German and Norwegian heritage plan European trips.",
    },
    {
      q: "What if I need a passport for a last-minute trip to Wisconsin?",
      a: "Wisconsin travel does not require a passport. However, if your trip involves crossing into Canada or international travel, we can process your passport as fast as 24 hours with proof of travel.",
    },
    {
      q: "Are there passport acceptance facilities near Winona?",
      a: "The Winona Post Office, La Crosse Post Office (WI), and Rochester Post Office all accept passport applications. We can guide you to the best option based on your schedule and situation.",
    },
  ],
  testimonials: [
    {
      name: "Sarah K.",
      location: "Winona, MN",
      rating: 5,
      text: "I'm a Winona State student studying abroad in Spain next semester. I discovered my passport had expired only three weeks before my departure. Fast Passport Center processed my renewal in four business days. I made my program and had the best semester of my life in Barcelona. Cannot recommend them enough.",
      service: "Student Renewal",
    },
    {
      name: "The Hoffmann Family",
      location: "Winona, MN",
      rating: 5,
      text: "We planned a German heritage trip to visit our ancestral villages in Bavaria. We had six weeks and all four family passports were expired. Fast Passport Center processed everything in seven business days. The checklist was so helpful and we had a wonderful trip reconnecting with our roots.",
      service: "Family Renewal",
    },
    {
      name: "Dr. Martinez",
      location: "Winona, MN",
      rating: 5,
      text: "I had a last-minute conference invitation in Toronto with two weeks notice. My passport was expired. Fast Passport Center processed my renewal in five business days. I presented my research at the conference and made important connections. Excellent service.",
      service: "Business Renewal",
    },
  ],
  nearbyLinks: [
    { name: "Rochester", href: "/cities/rochester-mn" },
    { name: "La Crosse", href: "/cities/la-crosse" },
    { name: "Minneapolis", href: "/cities/minneapolis" },
    { name: "St. Paul", href: "/cities/st-paul" },
    { name: "Mankato", href: "/cities/mankato" },
    { name: "Northfield", href: "/cities/northfield" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Winona",
  introDescription: "Fast passport processing for Winona and southeast Minnesota river bluff country travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Winona and southeast Minnesota resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Winona Post Office",
      address: "402 E Broadway St, Winona, MN 55987",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(507) 454-6400",
      notes: "Primary passport acceptance facility for Winona and Winona County residents. Appointment required. Call ahead for photo availability.",
    },
    {
      name: "La Crosse Post Office (WI)",
      address: "250 Monitor St, La Crosse, WI 54603",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(608) 782-5024",
      notes: "Just across the river in Wisconsin. Full passport services. Convenient for Winona residents.",
    },
    {
      name: "Rochester Post Office",
      address: "3111 6th St NW, Rochester, MN 55901",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(507) 529-4700",
      notes: "Olmsted County. Full passport services. Convenient for Winona residents driving east.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Winona", address: "Walmart area, Winona, MN", hours: "Call for hours" },
    { name: "CVS Pharmacy — Winona", address: "Winona commercial area", hours: "Daily 7 AM – 10 PM" },
    { name: "Walmart — Winona", address: "Winona commercial area", hours: "Call for hours" },
    { name: "The UPS Store — Winona", address: "Winona commercial area", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Winona DVS Office",
      address: "202 W 3rd St, Winona, MN 55987",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Winona County Driver and Vehicle Services. Driver licenses, REAL ID, and passport-related ID verification.",
      featured: true,
    },
    {
      name: "La Crosse DMV (WI)",
      address: "La Crosse, WI area",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Wisconsin DMV. Full driver and vehicle services. Convenient for Winona residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "LSE",
      name: "La Crosse Regional Airport",
      distance: "About 25 miles from Winona — 35 minutes by car",
      address: "2850 Airport Rd, La Crosse, WI 54603",
      note: "Regional airport for Winona residents. Direct flights to Chicago and Minneapolis. Closest commercial airport.",
      flightUrl: "https://www.lacrosseairport.com/",
      flightLabel: "La Crosse Regional Airport",
      featured: true,
    },
    {
      code: "RST",
      name: "Rochester International Airport",
      distance: "About 45 miles from Winona — 50 minutes by car",
      address: "7600 Helgerson Dr SW, Rochester, MN 55902",
      note: "Regional airport for Winona residents. Direct flights to Atlanta, Chicago, and Minneapolis. Full international connections.",
      flightUrl: "https://www.flyrst.com/",
      flightLabel: "Rochester International Airport",
      featured: false,
    },
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 120 miles from Winona — 2 hours by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Major international airport for Winona residents. Full international flight service. Access via I-90 and Highway 61.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "Study Abroad & Academic Travel",
      subtitle: "Winona State and Saint Mary's students with international programs",
      content:
        "Winona State University and Saint Mary's University of Minnesota maintain active study abroad programs in Europe, Asia, and Latin America. Students often discover passport issues during pre-departure orientation. Semester programs typically require departure in August or January, while summer programs leave in May.",
      tip: "Study abroad deadlines are non-negotiable. Start your passport renewal the moment you are accepted into a program.",
      icon: "ri-book-open-line",
    },
    {
      title: "European Heritage & Cultural Travel",
      subtitle: "German and Norwegian heritage trips for Winona's multi-generational families",
      content:
        "Many Winona families trace their roots to German and Norwegian immigrants who settled in the Mississippi River valley. Heritage trips to Germany, Norway, and Sweden are popular among multi-generational families, often planned for summer or during the off-season.",
      tip: "European heritage trips are often planned 6+ months in advance. Start passport renewals early to avoid last-minute stress.",
      icon: "ri-earth-line",
    },
    {
      title: "River Valley Recreation & Wisconsin Travel",
      subtitle: "Cross-river recreation and shopping trips for Winona residents",
      content:
        "Winona residents regularly cross the Mississippi into Wisconsin for work, recreation, and shopping. The scenic Great River Road provides a beautiful drive between the two states. Summer brings festival season on both sides of the river.",
      tip: "Wisconsin travel does not require a passport. Keep your REAL ID current for domestic travel.",
      icon: "ri-road-map-line",
    },
    {
      title: "Rochester & La Crosse Medical Corridor",
      subtitle: "Medical professionals traveling for conferences, training, and research",
      content:
        "Winona is part of a larger medical corridor that includes Rochester (Mayo Clinic) and La Crosse. Medical professionals from Winona frequently travel for international conferences, training programs, and research collaborations. The Gundersen Health System and Mayo Clinic connections create ongoing international travel needs.",
      tip: "Conference invitations often come with short notice. Maintain passport validity if you are in a field with international conferences.",
      icon: "ri-hospital-line",
    },
  ],
  destinations: [
    {
      name: "Spain",
      context: "Study abroad semester programs for Winona State and Saint Mary's students",
      urgency: "Semester departure dates are fixed — passport must be ready before orientation",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "Heritage travel for Winona's German-American community and Bavarian tourism",
      urgency: "Summer German travel and Oktoberfest trips are planned months ahead",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Norway",
      context: "Scandinavian heritage trips for families with Norwegian roots",
      urgency: "Summer Norwegian travel is popular with multi-generational families",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Canada",
      context: "Toronto and Vancouver conferences for medical and academic professionals",
      urgency: "Conference invitations often arrive with 2–3 weeks notice",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Japan",
      context: "Academic exchanges and cultural programs for university students",
      urgency: "Study abroad programs to Japan have strict departure timelines",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Mexico",
      context: "Winter break and spring break trips for students and families",
      urgency: "Break trips are often booked 3–4 weeks out",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    { stat: "35%", label: "of Winona expedited requests are study abroad students from Winona State and Saint Mary's" },
    { stat: "3–4 Weeks", label: "most common advance notice when students discover passport issues before semester programs" },
    { stat: "Aug–Jan", label: "peak travel season for study abroad semester programs departing from Winona" },
    { stat: "5–7 Days", label: "typical expedited processing time for Winona clients choosing our recommended option" },
  ],
};

export default function WinonaMNPage() {
  return <CityPage data={data} />;
}